module.exports = __webpack_public_path__ + "media/images/about400x300-03c0559a0881d719dd4598df17e6289b.png";